import {onBlockLoaded} from "@plaudit/frontend-apis";
import {execute_with_consent} from "@plaudit/analytics-integrations-api";

onBlockLoaded({
	blockOrClassName: "plaudit-query-loop-maps/google-map",
	onAdd(element: HTMLElement) {
		execute_with_consent({
			handles: 'plaudit-base/google-maps-api',
			allowed() {
				element.classList.toggle("google-maps-permission-granted", true);
				element.classList.remove("google-maps-permission-waiting");
			},
			denied() {
				element.classList.toggle("google-maps-permission-not-granted", true);
				element.classList.remove("google-maps-permission-waiting");
			}
		});
	}
});
